module.exports = __webpack_public_path__ + "static/media/link.0d81f6da.svg";